/* tslint:disable */
import { CDK_DRAG_CONFIG } from '@angular/cdk/drag-drop';
import { APP_BASE_HREF, AsyncPipe, registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localePt from '@angular/common/locales/pt';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NbMomentDateModule } from '@nebular/moment';
import { NbDatepickerModule } from '@nebular/theme';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToasterModule } from 'angular2-toaster';
import { AmplifyAngularModule, AmplifyService } from 'aws-amplify-angular';
import { NgWizardConfig, NgWizardModule, NgWizardService, THEME } from 'dapda-ng-wizard';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { NgxSpinnerModule } from 'ngx-spinner';
import { environment } from '../environments/environment';
import { CoreModule } from './@core/core.module';
import { AuthGuard } from './@core/guards/auth.guard';
import { RoleGuard } from './@core/guards/role.guard';
import { TestABGuard } from './@core/guards/testab.guard';
import { ThemeModule } from './@theme/theme.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GraphQlModule } from './graph-ql/graph-ql.module';
import { MenuService } from './pages/menu.service';
import { ModalsModule } from './pages/modals/modals.module';
import { ModeMaintenanceComponent } from './pages/mode-maintenance/mode-maintenance.component';
import { SentryErrorHandler } from './sentry.service';
import { PipesModule } from './shared/pipes/pipes.module';
import { AdminService } from './shared/services/admin/admin.service';
import { AssignmentRulesService } from './shared/services/assignmentRules/assignment-rules.service';
import { CreateAssignmentRulesService } from './shared/services/assignmentRules/create-assignment-rules.service';
import { BrandService } from './shared/services/brand/brand.service';
import { ChannelService } from './shared/services/channel/channel.service';
import { ChatService } from './shared/services/chat/chat.service';
import { Company360Service } from './shared/services/dapda360/company360.service';
import { DealerService } from './shared/services/dealer/dealer.service';
import { MessagingService } from './shared/services/firebase/messaging.service';
import { HistoricService } from './shared/services/historic/historic.service';
import { LeadService } from './shared/services/lead/lead.service';
import { LeadTypeService } from './shared/services/leadType/lead.type.service';
import { NotificationService } from './shared/services/notification/notification.service';
import { GraphqlErrorHandler } from './shared/services/security/graphql-error-handler.service';
import { StatusService } from './shared/services/status/status.service';
import { UserService } from './shared/services/user/user.service';
import { StylesProvider } from './shared/services/utils/styles.provider';
import { TranslatorService } from './shared/services/utils/translator.service';
import { VehicleFiltersService } from './shared/services/vehicle/vehicle-filters.service';
import { VehicleService } from './shared/services/vehicle/vehicle.service';
import { SharedModule } from './shared/shared.module';
registerLocaleData(localeEs);
registerLocaleData(localeEn);
registerLocaleData(localeFr);
registerLocaleData(localePt);

const ngWizardConfig: NgWizardConfig = {
  theme: THEME.default
};

const DragConfig = {
  dragStartThreshold: 0,
  pointerDirectionChangeThreshold: 5,
  zIndex: 99999999999
};

@NgModule({
  declarations: [AppComponent, ModeMaintenanceComponent],
  imports: [
    AmplifyAngularModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    NgbModule,
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    GraphQlModule,
    SharedModule.forRoot(),
    ToasterModule.forRoot(),
    ModalsModule.forRoot(),
    NbMomentDateModule,
    NbDatepickerModule.forRoot(),
    NgxSpinnerModule,
    ServiceWorkerModule.register('/sw-master.js', { enabled: environment.production }),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    PipesModule,
    DeviceDetectorModule.forRoot(),
    NgWizardModule.forRoot(ngWizardConfig),
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: LOCALE_ID, deps: [TranslatorService], useFactory: translatorService => translatorService.getLanguage() },
    { provide: ErrorHandler, useClass: SentryErrorHandler },
    AuthGuard,
    TestABGuard,
    BrandService,
    ChannelService,
    StatusService,
    LeadTypeService,
    UserService,
    DealerService,
    LeadService,
    HistoricService,
    NotificationService,
    { provide: APP_BASE_HREF, useValue: '/' },
    AuthGuard,
    AmplifyService,
    MessagingService,
    AsyncPipe,
    MenuService,
    GraphqlErrorHandler,
    RoleGuard,
    ChatService,
    StylesProvider,
    AdminService,
    VehicleService,
    VehicleFiltersService,
    Company360Service,
    AssignmentRulesService,
    CreateAssignmentRulesService,
    { provide: CDK_DRAG_CONFIG, useValue: DragConfig },
  ]
})
export class AppModule {
}
